import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/app.css";
import "./styles/extensions.css";
import "./styles/compact.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
